import React from 'react';
import { RadialBarChart, RadialBar } from 'recharts';

const RiskIndicator = ({ status: products }) => {
  console.log(products, 'selected');

  // Filter selected products (true values)
  const selectedProducts = products.filter((product) => product);
  const selectedPercentage = (selectedProducts.length / products.length) * 100;
  console.log(selectedPercentage,'perectn')

  // Get risk level based on selection percentage
  const getRiskLevel = () => {
    if (selectedPercentage === 100) return { color: "#00C49F", text: "You are fully covered! Low risk." }; // Green
    if (selectedPercentage >= 75) return { color: "#FFEB3B", text: "Moderate risk: Some coverage missing." }; // Yellow
    if (selectedPercentage >= 50) return { color: "#FF4500", text: "High risk: Consider adding more coverage." }; // Orangered
    return { color: "#FF0000", text: "Very high risk! Important protections are missing." }; // Red
  };
  

  const riskData = getRiskLevel();

  // Recharts Data
  const data = [{ value: selectedPercentage, fill: riskData.color }];

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
     <RadialBarChart
        width={250}
        height={90}
        innerRadius="50%"
        outerRadius="100%"
        style={{justifySelf:'center'}}
        data={data}
        startAngle={180}
        endAngle={0}
      >
        <RadialBar minAngle={15} clockWise dataKey="value" />
      </RadialBarChart>
      <p style={{ fontSize: "16px", fontWeight: "bold", color: riskData.color }}>
        ⚠️ {riskData.text}
      </p>
    </div>
  );
};

export default RiskIndicator;
